var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.0667V9.93342C1 6.03672 1 4.08785 2.33478 2.87781C3.66956 1.66778 5.81636 1.66675 10.1111 1.66675H12.3889C16.6836 1.66675 18.8316 1.66675 20.1652 2.87781C21.4989 4.08888 21.5 6.03672 21.5 9.93342V14.0667C21.5 17.9634 21.5 19.9123 20.1652 21.1223C18.8304 22.3324 16.6836 22.3334 12.3889 22.3334H10.1111C5.81636 22.3334 3.66842 22.3334 2.33478 21.1223C1.00114 19.9113 1 17.9634 1 14.0667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4904 10.6226C11.6919 11.7128 13.275 12.8205 13.275 12.8205L15.4434 10.852C15.4434 10.852 14.2225 9.41568 13.0221 8.32552C11.8195 7.23638 10.2364 6.12762 10.2364 6.12762L8.06796 8.09612C8.06796 8.09612 9.28885 9.53245 10.4904 10.6226ZM10.4904 10.6226L6.69446 14.0667M15.8056 10.5234L12.9128 13.1481M10.6008 5.80005L7.70807 8.42472M6.69446 18.2H15.8056",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalSupport);
export default __webpack_public_path__ + "static/media/legal-support.380717f0c76f754e899794e398aa6317.svg";
export { ForwardRef as ReactComponent };